import { formatMoney as _formatMoney } from './util';

export default function trackAddToBag (product, delta) {
    if (delta === 0) throw new TypeError('delta must not === 0');

    var color = product.variant.options[
        product.options.findIndex(function (option) {
            return /color/i.test(option.name);
        })
    ];

    var size = product.variant.options[
        product.options.findIndex(function (option) {
            return /size/i.test(option.name);
        })
    ];

    var products = [
        {
            name: product.title,
            id: product.id.toString(),
            price: _formatMoney(product.price),
            brand: product.vendor,
            category: product.type || undefined,
            variant: product.variant.title.toString(),
            quantity: Math.abs(delta).toString(),
            url: product.url,
            // variant color
            dimension5: color || undefined,
            // variant size
            dimension6: size || undefined,
            // product 'price type'
            dimension15: (
                product.variant.compare_at_price &&
                (product.variant.compare_at_price > product.variant.price)
            )
                ? 'sale'
                : 'msrp',
            // msrp
            metric2: _formatMoney(product.variant.compare_at_price || product.variant.price),
        },
    ];

    var event = {
        event: delta > 0 ? 'add-to-bag' : 'remove-from-bag',
        ecommerce: { currencyCode: window.Shopify.currency.active || undefined },
    };

    if (delta > 0) {
        event.ecommerce.add = { products: products };
    } else {
        event.ecommerce.remove = { products: products };
    }

    window.dataLayer.push(event);
}